export const systemMessages = {
  "zh_hans": {
    "system.friendAdded": "好友申请已通过，你们现在可以开始聊天",
    "system.recalled": "[已撤回]",
    "system.image": "[图片]",
    "system.file": "[文件]",
    "system.voice": "[语音]",
    "connection.connected": "已连接",
    "connection.disconnected": "未连接",
    "connection.connecting": "连接中",
    "connection.failed": "连接失败",
    "connection.syncing": "同步中",
    "connection.syncFailed": "同步失败",
    "connection.announcementOnly": "公告群，仅管理员可发言"
  },
  "zh_hant": {
    "system.friendAdded": "好友申請已通過，你們現在可以開始聊天",
    "system.recalled": "[已撤回]",
    "system.image": "[圖片]",
    "system.file": "[檔案]",
    "system.voice": "[語音]",
    "connection.connected": "已連線",
    "connection.disconnected": "未連線",
    "connection.connecting": "連線中",
    "connection.failed": "連線失敗",
    "connection.syncing": "同步中",
    "connection.syncFailed": "同步失敗",
    "connection.announcementOnly": "公告群組，僅管理員可發言"
  },
  "en": {
    "system.friendAdded": "Friend request accepted. You can now start chatting.",
    "system.recalled": "[Recalled]",
    "system.image": "[Image]",
    "system.file": "[File]",
    "system.voice": "[Voice]",
    "connection.connected": "Connected",
    "connection.disconnected": "Disconnected",
    "connection.connecting": "Connecting",
    "connection.failed": "Connection failed",
    "connection.syncing": "Syncing",
    "connection.syncFailed": "Sync failed",
    "connection.announcementOnly": "Announcement group: only administrators can post."
  },
  "lo": {
    "system.friendAdded": "ຄຳຂໍເປັນໝູ່ໄດ້ຮັບການຍອມຮັບແລ້ວ ທ່ານສາມາດເລີ່ມສົນທະນາໄດ້.",
    "system.recalled": "[ຖອນຄືນແລ້ວ]",
    "system.image": "[ຮູບພາບ]",
    "system.file": "[ໄຟລ໌]",
    "system.voice": "[ສຽງ]",
    "connection.connected": "ເຊື່ອມຕໍ່ແລ້ວ",
    "connection.disconnected": "ຍັງບໍ່ເຊື່ອມຕໍ່",
    "connection.connecting": "ກຳລັງເຊື່ອມຕໍ່",
    "connection.failed": "ເຊື່ອມຕໍ່ບໍ່ສຳເລັດ",
    "connection.syncing": "ກຳລັງຊິງຂໍ້ມູນ",
    "connection.syncFailed": "ຊິງຂໍ້ມູນບໍ່ສຳເລັດ",
    "connection.announcementOnly": "ກຸ່ມປະກາດ: ມີພຽງຜູ້ດູແລທີ່ສົ່ງຂໍ້ຄວາມໄດ້.",
    "list.unread": "{count} ຂໍ້ຄວາມຍັງບໍ່ໄດ້ອ່ານ",
    "list.unreadMessages": "{count} ຂໍ້ຄວາມຍັງບໍ່ໄດ້ອ່ານ",
    "list.searchConversationContact": "ຄົ້ນຫາການສົນທະນາ ຫຼືຜູ້ຕິດຕໍ່",
    "list.noMatches": "ບໍ່ພົບຜົນລັບ",
    "list.tryAnotherKeyword": "ລອງໃຊ້ຄຳຄົ້ນຫາອື່ນ",
    "list.noConversations": "ຍັງບໍ່ມີການສົນທະນາ",
    "list.conversationHint": "ການສົນທະນາຈະສະແດງຢູ່ນີ້ເມື່ອໄດ້ຮັບ ຫຼືສົ່ງຂໍ້ຄວາມ.",
    "list.newConversation": "ສ້າງການສົນທະນາໃໝ່",
    "composer.shortcut": "Enter ເພື່ອສົ່ງ · ກົດຄ້າງໄມໂຄຣໂຟນເພື່ອເວົ້າ"
  },
  "km": {
    "system.friendAdded": "សំណើមិត្តភក្តិត្រូវបានយល់ព្រម។ អ្នកអាចចាប់ផ្តើមជជែកបានឥឡូវនេះ។",
    "system.recalled": "[បានដកសារ]",
    "system.image": "[រូបភាព]",
    "system.file": "[ឯកសារ]",
    "system.voice": "[សំឡេង]",
    "connection.connected": "បានភ្ជាប់",
    "connection.disconnected": "មិនទាន់ភ្ជាប់",
    "connection.connecting": "កំពុងភ្ជាប់",
    "connection.failed": "ការភ្ជាប់បរាជ័យ",
    "connection.syncing": "កំពុងធ្វើសមកាលកម្ម",
    "connection.syncFailed": "សមកាលកម្មបរាជ័យ",
    "connection.announcementOnly": "ក្រុមប្រកាស៖ មានតែអ្នកគ្រប់គ្រងអាចផ្ញើសារ។",
    "list.unread": "{count} មិនទាន់អាន",
    "list.unreadMessages": "សារ {count} មិនទាន់អាន",
    "list.searchConversationContact": "ស្វែងរកការសន្ទនា ឬទំនាក់ទំនង",
    "list.noMatches": "គ្មានលទ្ធផលត្រូវគ្នា",
    "list.tryAnotherKeyword": "សាកល្បងពាក្យស្វែងរកផ្សេង",
    "list.noConversations": "មិនទាន់មានការសន្ទនា",
    "list.conversationHint": "ការសន្ទនានឹងបង្ហាញនៅទីនេះពេលអ្នកទទួល ឬផ្ញើសារ។",
    "list.newConversation": "ការសន្ទនាថ្មី",
    "composer.shortcut": "Enter ដើម្បីផ្ញើ · ចុចសង្កត់មីក្រូហ្វូនដើម្បីនិយាយ"
  },
  "th": {
    "system.friendAdded": "คำขอเป็นเพื่อนได้รับการยอมรับแล้ว คุณสามารถเริ่มแชตได้",
    "system.recalled": "[เรียกคืนแล้ว]",
    "system.image": "[รูปภาพ]",
    "system.file": "[ไฟล์]",
    "system.voice": "[เสียง]",
    "connection.connected": "เชื่อมต่อแล้ว",
    "connection.disconnected": "ยังไม่ได้เชื่อมต่อ",
    "connection.connecting": "กำลังเชื่อมต่อ",
    "connection.failed": "เชื่อมต่อไม่สำเร็จ",
    "connection.syncing": "กำลังซิงค์",
    "connection.syncFailed": "ซิงค์ไม่สำเร็จ",
    "connection.announcementOnly": "กลุ่มประกาศ: เฉพาะผู้ดูแลระบบเท่านั้นที่ส่งข้อความได้",
    "list.unread": "ยังไม่ได้อ่าน {count} ข้อความ",
    "list.unreadMessages": "ยังไม่ได้อ่าน {count} ข้อความ",
    "list.searchConversationContact": "ค้นหาแชตหรือผู้ติดต่อ",
    "list.noMatches": "ไม่พบผลลัพธ์",
    "list.tryAnotherKeyword": "ลองใช้คำค้นอื่น",
    "list.noConversations": "ยังไม่มีแชต",
    "list.conversationHint": "แชตจะแสดงที่นี่เมื่อคุณได้รับหรือส่งข้อความ",
    "list.newConversation": "สร้างแชตใหม่",
    "composer.shortcut": "Enter เพื่อส่ง, Shift + Enter เพื่อขึ้นบรรทัดใหม่"
  },
  "vi": {
    "system.friendAdded": "Yêu cầu kết bạn đã được chấp nhận. Bạn có thể bắt đầu trò chuyện.",
    "system.recalled": "[Đã thu hồi]",
    "system.image": "[Hình ảnh]",
    "system.file": "[Tệp]",
    "system.voice": "[Giọng nói]",
    "connection.connected": "Đã kết nối",
    "connection.disconnected": "Chưa kết nối",
    "connection.connecting": "Đang kết nối",
    "connection.failed": "Kết nối thất bại",
    "connection.syncing": "Đang đồng bộ",
    "connection.syncFailed": "Đồng bộ thất bại",
    "connection.announcementOnly": "Nhóm thông báo: chỉ quản trị viên có thể gửi tin nhắn.",
    "list.unread": "{count} chưa đọc",
    "list.unreadMessages": "{count} tin nhắn chưa đọc",
    "list.searchConversationContact": "Tìm cuộc trò chuyện hoặc liên hệ",
    "list.noMatches": "Không có kết quả phù hợp",
    "list.tryAnotherKeyword": "Thử từ khóa khác",
    "list.noConversations": "Chưa có cuộc trò chuyện",
    "list.conversationHint": "Cuộc trò chuyện sẽ hiển thị ở đây khi bạn nhận hoặc gửi tin nhắn.",
    "list.newConversation": "Cuộc trò chuyện mới",
    "composer.shortcut": "Enter để gửi, Shift + Enter để xuống dòng"
  }
};
